import { Box, Typography } from "@mui/material";
import React from "react";
import { Check } from "../../../Assets/Icons/Check";
import Edit from "../../../Assets/Icons/Edit";
import { Chat } from "../../../Assets/Icons/Chat";
import Journy from "../../../Components/Details.jsx/Journy";
import Rejection from "../../../Components/Details.jsx/Rejection";

const datas = [
  {
    id: 1,
    title: "Hospital Onboarding",
  },
  {
    id: 1,
    title: "Medical Head Approved",
  },
  {
    id: 1,
    title: "Finance Details Added",
  },
  {
    id: 1,
    title: "Finance Head Approved",
  },
  {
    id: 1,
    title: "Insurance Details Added",
  },
  {
    id: 1,
    title: "Insurance Head Approved",
  },
  {
    id: 1,
    title: "Ops Head Approved",
  },
  {
    id: 1,
    title: "Super Admin Approved",
  },
];

const Details = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#F9FBFC",
        width: "77%",
        maxHeight: "90vh",
        margin: "5px  25px",
        borderRadius: "20px",
        padding: "25px",
        overflowY: "scroll",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "40px 40px  10px 30px",
        }}
      >
        <Box
          display={"flex"}
          gap={1}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Box>{"<"}</Box>
          <Typography sx={{ fontWeight: 600, fontSize: "22px" }}>
            Silverline Hospital
          </Typography>
          <Box
            component={"button"}
            width={"96px"}
            height={"26px"}
            border={"solid 1px #66718A"}
            bgcolor={"#545E75"}
            color={"white"}
            fontSize={"12px"}
            borderRadius={"8px"}
          >
            ID: #123456
          </Box>
        </Box>

        <Box display={"flex"} gap={1}>
          <Box
            component={"button"}
            width={"136px"}
            height={"36px"}
            border={"solid 1px #66718A"}
            bgcolor={"#F9FBFC"}
            color={"#4C5A6A"}
            fontSize={"14px"}
            borderRadius={"8px"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={1}
          >
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Edit />
            </Box>
            <Typography> Disable Item</Typography>
          </Box>
          <Box
            component={"button"}
            width={"136px"}
            height={"36px"}
            border={"solid 1px #66718A"}
            bgcolor={"#F9FBFC"}
            color={"#4C5A6A"}
            fontSize={"14px"}
            borderRadius={"8px"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={1}
          >
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Edit />
            </Box>
            <Typography>Edit Request</Typography>
          </Box>
          <Box
            component={"button"}
            width={"136px"}
            height={"36px"}
            border={"solid 1px #65DEC7"}
            bgcolor={"#17DFBA"}
            color={"white"}
            fontSize={"14px"}
            borderRadius={"8px"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={1}
          >
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Check />
            </Box>
            <Typography>Disable Item</Typography>
          </Box>
          <Box
            component={"button"}
            width={"100px"}
            height={"36px"}
            border={"solid 1px #66718A"}
            bgcolor={"#545E75"}
            color={"white"}
            fontSize={"14px"}
            borderRadius={"8px"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={1}
          >
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Chat />
            </Box>
            <Typography>Chat</Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          backgroundColor: "#EBF1F3",
          height: "10vh",
          margin: "25px  0px",
          borderRadius: "20px",
          display: "flex",
          justifyContent: "space-around",
          paddingTop: "35px",
        }}
      >
        <Journy datas={datas} />
      </Box>

      <Box
        sx={{
          margin: "5px  25px",
          borderRadius: "20px",
          border: "1px solid #DCE5E9",
          padding: "20px",
          marginTop: "25px",
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <Box display={"flex"} alignItems={"center"} gap={2}>
          <Typography color={"#4C5A6A"} fontSize={"18px"} fontWeight={"600"}>
            General Information
          </Typography>
          <Box
            width={"220px"}
            border={"1px solid #65DEC7"}
            borderRadius={"17px"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={1}
            padding={"2px 10px"}
            bgcolor={"#EFFEF5"}
          >
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Check />
            </Box>
            <Typography color={"#2E2E2E"} fontSize={"14x"}>
              Added as mykare doctor
            </Typography>
          </Box>
          <Box
            width={"220px"}
            border={"1px solid #65DEC7"}
            borderRadius={"17px"}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={1}
            padding={"2px 10px"}
            bgcolor={"#EFFEF5"}
          >
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Check />
            </Box>
            <Typography color={"#2E2E2E"} fontSize={"14x"}>
              Added as mykare doctor
            </Typography>
          </Box>
        </Box>
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          gap={2}
        >
          <Box width={"386px"}>
            <Typography color={"#2E2E2E"} fontSize={"14px"}>
              Hospital name
            </Typography>
            <Typography color={"#4C5A6A"} fontSize={"16px"}>
              Silverline Hospital
            </Typography>
          </Box>
          <Box width={"386px"}>
            <Typography color={"#2E2E2E"} fontSize={"14px"}>
              Location
            </Typography>
            <Typography color={"#4C5A6A"} fontSize={"16px"}>
              Kochi
            </Typography>
          </Box>
          <Box>
            <Typography color={"#2E2E2E"} fontSize={"14px"}>
              Address
            </Typography>
            <Typography color={"#4C5A6A"} fontSize={"16px"} width={"386px"}>
              KP Vallon Rd, Giri Nagar, Kadavanthra, Ernakulam, Kerala 682020
            </Typography>
          </Box>
        </Box>
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          gap={2}
        >
          <Box width={"386px"}>
            <Typography color={"#2E2E2E"} fontSize={"14px"}>
              Contact number
            </Typography>
            <Typography color={"#4C5A6A"} fontSize={"16px"}>
              +91 9874 654 123
            </Typography>
          </Box>
          <Box width={"386px"}>
            <Typography color={"#2E2E2E"} fontSize={"14px"}>
              Alternate Contact number
            </Typography>
            <Typography color={"#4C5A6A"} fontSize={"16px"}>
              +91 9874 654 123
            </Typography>
          </Box>
          <Box>
            <Typography color={"#2E2E2E"} fontSize={"14px"}>
              Email
            </Typography>
            <Typography color={"#4C5A6A"} fontSize={"16px"} width={"386px"}>
              dr.deepak@gmail.com
            </Typography>
          </Box>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"} gap={2}>
          <Box width={"386px"}>
            <Typography color={"#2E2E2E"} fontSize={"14px"}>
              Doctors
            </Typography>
            <Typography color={"#4C5A6A"} fontSize={"16px"}>
              Dr. Balamurugan M
            </Typography>{" "}
            <Typography color={"#4C5A6A"} fontSize={"16px"}>
              Dr. Robert Mao
            </Typography>{" "}
            <Typography color={"#4C5A6A"} fontSize={"16px"}>
              Dr. V M Thomas
            </Typography>{" "}
            <Typography color={"#4C5A6A"} fontSize={"16px"}>
              Dr. Kailash A Jain
            </Typography>{" "}
            <Typography color={"#4C5A6A"} fontSize={"16px"}>
              Dr. Manoj P Nair
            </Typography>
          </Box>
          <Box width={"386px"}>
            <Typography color={"#2E2E2E"} fontSize={"14px"}>
              Hospital Doc.
            </Typography>
            <Box
              width={"80px"}
              height={"80px"}
              bgcolor={"#4C5A6A"}
              borderRadius={"8px"}
            />
          </Box>
          <Box width={"386px"}>
            <Typography color={"#2E2E2E"} fontSize={"14px"}>
              Hospital Doc.
            </Typography>
            <Box display={"flex"} gap={1}>
              <Box
                width={"80px"}
                height={"80px"}
                bgcolor={"#4C5A6A"}
                borderRadius={"8px"}
              />
              <Box
                width={"80px"}
                height={"80px"}
                bgcolor={"#4C5A6A"}
                borderRadius={"8px"}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Rejection />
      <Box
        sx={{
          margin: "5px  25px",
          borderRadius: "20px",
          border: "1px solid #DCE5E9",
          padding: "20px",
          marginTop: "25px",
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <Box>
          <Typography color={"#4C5A6A"} fontSize={"16px"} fontWeight={"600"}>
            About Hospital
          </Typography>
        </Box>
        <Box>
          <Typography color={"#4C5A6A"} fontSize={"12px"} fontWeight={"600"}>
            About
          </Typography>
          <Typography color={"#4C5A6A"} fontSize={"13px"}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit
            similique vel explicabo repellat soluta? Alias ipsa saepe nisi
            beatae dolorem fugiat, velit repudiandae minima. Debitis tempore
            placeat est! Illo, consequuntur! Lorem ipsum dolor sit amet
            consectetur adipisicing elit. Suscipit similique vel explicabo
            repellat soluta? Alias ipsa saepe nisi beatae dolorem fugiat, velit
            repudiandae minima. Debitis tempore placeat est! Illo, consequuntur!
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit
            similique vel explicabo repellat soluta? Alias ipsa saepe nisi
            beatae dolorem fugiat, velit repudiandae minima. Debitis tempore
            placeat est! Illo, consequuntur! Lorem ipsum dolor sit amet
            consectetur adipisicing elit. Suscipit similique vel explicabo
            repellat soluta? Alias ipsa saepe nisi beatae dolorem fugiat, velit
            repudiandae minima. Debitis tempore placeat est! Illo, consequuntur!
          </Typography>
        </Box>
        {/* <Box>
          <Typography color={"#4C5A6A"} fontSize={"16px"} fontWeight={"600"}>
            About Hospital
          </Typography>
          <Typography
            width={"60%"}
            bgcolor={"#ECF1F5"}
            borderRadius={"8px"}
            display={"flex"}
            alignItems={"center"}
          ></Typography>
        </Box> */}
      </Box>
    </Box>
  );
};

export default Details;
